(function () {
  'use strict';

  if (window.__mmSuggestedRailsInit) return;
  window.__mmSuggestedRailsInit = true;

  var RAIL_SELECTOR = '[data-mm-scroll-rail]';
  var globalObserver = null;
  /** @type {WeakMap<Element, number>} */
  var debounceTimers = new WeakMap();
  var DEBOUNCE_MS = 48;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function asElements(targets) {
    if (!targets) return [];
    if (targets.jquery && typeof targets.toArray === 'function') return targets.toArray();
    if (Array.isArray(targets)) return targets;
    if (typeof targets.length === 'number' && !targets.nodeType && typeof targets !== 'string') {
      return toArray(targets);
    }
    return [targets];
  }

  function removeNode(node) {
    if (!node || !node.parentNode) return;
    try {
      node.parentNode.removeChild(node);
    } catch (err) {
      // Flickity may reparent the same nodes while we unwrap; ignore races.
    }
  }

  function getFlickityInstance(rail) {
    var Flickity = window.Flickity;
    if (!Flickity || typeof Flickity.data !== 'function') return null;

    try {
      return Flickity.data(rail);
    } catch (error) {
      return null;
    }
  }

  function releaseInstanceEvents(rail, instance) {
    if (!rail || !instance) return;

    ['mousedown', 'touchstart', 'pointerdown', 'click'].forEach(function (eventName) {
      try {
        rail.removeEventListener(eventName, instance);
        rail.removeEventListener(eventName, instance, true);
      } catch (error) {}
    });

    ['unbindDrag', 'unbindHandles', 'deactivate'].forEach(function (methodName) {
      if (typeof instance[methodName] !== 'function') return;

      try {
        instance[methodName]();
      } catch (error) {}
    });
  }

  function neutralizeInstance(instance) {
    if (!instance || instance.__mmSuggestedRailNeutralized) return;

    instance.resize = function () {};
    instance.selectCell = function () {};
    instance.previous = function () {};
    instance.next = function () {};
    instance.destroy = function () {};
    instance.remove = function (targets) {
      asElements(targets).forEach(removeNode);
    };
    instance.__mmSuggestedRailNeutralized = true;
  }

  function clearRailState(rail) {
    rail.classList.remove('flickity-enabled', 'is-draggable', 'flickity-rtl');
    rail.removeAttribute('tabindex');
    rail.style.removeProperty('height');
    rail.style.removeProperty('touchAction');
    rail.style.removeProperty('touch-action');
    rail.style.removeProperty('userSelect');
    rail.style.removeProperty('user-select');
  }

  function resetCells(rail) {
    toArray(rail.querySelectorAll('.productgrid--item')).forEach(function (cell) {
      cell.classList.remove('is-selected', 'is-previous', 'is-next');
      cell.style.removeProperty('position');
      cell.style.removeProperty('left');
      cell.style.removeProperty('transform');
      cell.style.removeProperty('height');
    });
  }

  function moveFirstChildTo(parentFrom, parentTo, insertBefore) {
    var child = parentFrom.firstChild;
    if (!child) return false;
    try {
      if (insertBefore) {
        parentTo.insertBefore(child, insertBefore);
      } else {
        parentTo.appendChild(child);
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  function unwrapRail(rail) {
    toArray(rail.querySelectorAll('.flickity-prev-next-button, .flickity-page-dots')).forEach(removeNode);

    var viewport = rail.querySelector('.flickity-viewport');
    if (viewport) {
      var slider = viewport.querySelector('.flickity-slider');
      if (slider) {
        while (slider.firstChild && moveFirstChildTo(slider, rail, null)) {}
      } else {
        while (viewport.firstChild && moveFirstChildTo(viewport, rail, null)) {}
      }
      removeNode(viewport);
    }

    toArray(rail.querySelectorAll('.flickity-slider--wrapper')).forEach(function (wrapper) {
      var parent = wrapper.parentNode;
      if (!parent) return;

      while (wrapper.firstChild) {
        if (!moveFirstChildTo(wrapper, parent, wrapper)) break;
      }
      removeNode(wrapper);
    });

    toArray(rail.querySelectorAll('.flickity-slider')).forEach(function (slider) {
      var parent = slider.parentNode;
      if (!parent) return;

      while (slider.firstChild) {
        if (!moveFirstChildTo(slider, parent, slider)) break;
      }
      removeNode(slider);
    });
  }

  function needsCleanup(rail) {
    return rail.classList.contains('flickity-enabled')
      || !!rail.querySelector('.flickity-viewport')
      || !!rail.querySelector('.flickity-prev-next-button')
      || !!rail.querySelector('.flickity-page-dots');
  }

  function runSyncRail(rail) {
    if (!rail || !rail.isConnected || !needsCleanup(rail)) return;

    var observer = rail.__mmSuggestedRailObserver;

    if (observer) {
      try {
        observer.disconnect();
      } catch (e) {}
    }

    try {
      var instance = getFlickityInstance(rail);
      if (instance && !instance.__mmSuggestedRailDestroyed && typeof instance.destroy === 'function') {
        releaseInstanceEvents(rail, instance);

        try {
          instance.destroy();
        } catch (error) {}

        releaseInstanceEvents(rail, instance);
        neutralizeInstance(instance);
        instance.__mmSuggestedRailDestroyed = true;
      }

      unwrapRail(rail);
      clearRailState(rail);
      resetCells(rail);
    } finally {
      if (observer && rail.isConnected) {
        try {
          observer.observe(rail, {
            childList: true,
            attributes: true,
            attributeFilter: ['class'],
          });
        } catch (e) {}
      }
    }
  }

  function syncRail(rail) {
    if (!rail || !rail.isConnected || !needsCleanup(rail)) return;

    var pending = debounceTimers.get(rail);
    if (pending) {
      clearTimeout(pending);
    }

    debounceTimers.set(
      rail,
      setTimeout(function () {
        debounceTimers.delete(rail);
        if (!rail.isConnected) return;

        window.requestAnimationFrame(function () {
          if (!rail.isConnected) return;
          runSyncRail(rail);
        });
      }, DEBOUNCE_MS),
    );
  }

  /**
   * ProductRowScroller (Flickity) is created asynchronously after the recommendations
   * section HTML is injected (StaticProductRecommendations in empire.js). If we only react
   * to the first paint, Flickity can win and steal taps on mobile while horizontal swipes
   * still move the track. These delayed passes run after the theme finishes initing Flickity.
   */
  function scheduleDeferredFlickityCleanup(rail) {
    [0, 160, 420, 900, 2300].forEach(function (ms) {
      setTimeout(function () {
        if (!rail.isConnected) return;
        if (needsCleanup(rail)) syncRail(rail);
      }, ms);
    });
  }

  function bindRail(rail) {
    if (!rail || rail.__mmSuggestedRailBound) return;

    rail.__mmSuggestedRailBound = true;
    syncRail(rail);
    scheduleDeferredFlickityCleanup(rail);

    var railObserver = new MutationObserver(function (mutations) {
      var shouldSync = rail.classList.contains('flickity-enabled');

      if (!shouldSync) {
        shouldSync = mutations.some(function (mutation) {
          return mutation.type === 'attributes' || mutation.addedNodes.length > 0;
        });
      }

      if (shouldSync) {
        syncRail(rail);
      }
    });

    railObserver.observe(rail, {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    rail.__mmSuggestedRailObserver = railObserver;
  }

  function scan(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches && root.matches(RAIL_SELECTOR)) {
      bindRail(root);
    }

    if (!root.querySelectorAll) return;

    toArray(root.querySelectorAll(RAIL_SELECTOR)).forEach(bindRail);
  }

  function observeDocument() {
    if (globalObserver || !document.body) return;

    globalObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        toArray(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType === 1) {
            scan(node);
          }
        });
      });
    });

    globalObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    scan(document);
    observeDocument();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
    observeDocument();
  });
})();
